import { render, staticRenderFns } from "./RacuniZaUplate.vue?vue&type=template&id=4c85fc5e&scoped=true&"
import script from "./RacuniZaUplate.vue?vue&type=script&lang=js&"
export * from "./RacuniZaUplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c85fc5e",
  null
  
)

export default component.exports